module.exports = __webpack_public_path__ + "static/fonts/fa-brands-400.3654744.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-brands-400.woff2
// module id = 9iSo
// module chunks = 0